import './App.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {


  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState(""); // WRONG PASS

 // Brisanje starog tokena pre novog login-a ako postoji stari token
  const oldToken = localStorage.getItem("token");
  if (oldToken) localStorage.removeItem("token");
  
  const handleSubmit = async (e) => {
    e.preventDefault();
     try {
      const res = await fetch(`/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

       if (!res.ok) {
        if (res.status === 401) {
          setError("Pogrešan email ili lozinka."); // <-- prikazujemo grešku
        } else {
          setError("Došlo je do greške. Pokušajte ponovo.");
        }
        return; // više ne radimo navigate("/error")
      }

      const data = await res.json();
      localStorage.setItem("token", data.token);
      navigate("/Roleredirect");
    } catch (err) {
      setError("Došlo je do greške. Pokušajte ponovo." + err.message);
    }
  };

  return (  
    <div className="min-vh-100 bg-dark d-flex flex-column">
      {/* Navbar */}
      <nav className="navbar navbar-dark bg-dark shadow-sm">
        <div className="container">
          <a className="navbar-brand fw-bold" href="/">
            <span className="text-primary">Alpha</span>PremiumSolutions
          </a>
        </div>
      </nav>

      {/* Login Section */}
      <div
        className="flex-grow-1 d-flex align-items-center"
        style={{
          background:
            "linear-gradient(120deg, rgba(13,110,253,0.2), rgba(0,0,0,0.95))",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-5">
              <div className="card bg-black border-0 shadow-lg rounded-4">
                <div className="card-body p-5">
                  <h3 className="fw-bold text-white text-center mb-2">
                    Welcome back
                  </h3>
                  <p className="text-white-50 text-center mb-4">
                    Login to your AlphaPremiumSoulutions account
                  </p>

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label text-white-50">Email address</label>
                        <input
                        type="email"
                        className="form-control"
                        placeholder="you@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label text-white-50">Password</label>
                        <input
                        type="password"
                        className="form-control"
                        placeholder="••••••••"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        />
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <a href="/" className="text-primary text-decoration-none small">
                        Forgot password?
                        </a>
                    </div>

                    <button className="btn btn-primary w-100 py-2 fw-semibold">
                        Login
                    </button>
                </form>

                {error && (
                  <div className="text-danger text-center mb-3">
                    {error}
                  </div>
                )}


                  <div className="text-center mt-4">
                    <a
                      href="/"
                      className="text-white-50 text-decoration-none small"
                    >
                      ← Back to Home
                    </a>
                  </div>
                </div>
              </div>

              <p className="text-center text-white-50 small mt-4">
                © {new Date().getFullYear()} AlphaPremiumSoulutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}